module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "width": "800px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_c('strong', [_vm._v(_vm._s(_vm.title))])])]), _vm._v(" "), _c('v-card-text', [_c('v-row', _vm._l((_vm.posts), function(post, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "4"
      }
    }, [_c('Post', {
      attrs: {
        "post": post,
        "isSelected": _vm.selectedPostIds.has(post.shortcode)
      },
      on: {
        "selected": function($event) {
          return _vm.$emit('onSelect', post)
        }
      }
    })], 1)
  }), 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "small": "",
      "tile": "",
      "outlined": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('prev_page')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "left": ""
    }
  }, [_vm._v("mdi-chevron-left")]), _vm._v(" Back ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "small": "",
      "tile": "",
      "outlined": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('next_page')
      }
    }
  }, [_vm._v(" Next"), _c('v-icon', {
    attrs: {
      "small": "",
      "right": ""
    }
  }, [_vm._v("mdi-chevron-right")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Done")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-407f0b87"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scoped/campaign/PostView.vue
// module id = 2093
// module chunks = 0